import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Overview from '../components/Overview';
import Companies from '../components/Companies';
import Transactions from '../components/Transactions';
import SalaryCalculator from '../components/SalaryCalculator';
import ChangePassword from '../components/ChangePassword';

const Dashboard = () => {
  const { user, logout, isAdmin } = useAuth();
  const [activeTab, setActiveTab] = useState(isAdmin ? 'overview' : 'salary');

  const tabs = isAdmin
    ? [
        { id: 'overview', label: 'Overview' },
        { id: 'companies', label: 'Companies' },
        { id: 'transactions', label: 'Transactions' },
        { id: 'salary', label: 'Salary Calculator' },
        { id: 'settings', label: 'Settings' },
      ]
    : [
        { id: 'salary', label: 'My Salary' },
        { id: 'settings', label: 'Settings' },
      ];

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview />;
      case 'companies':
        return <Companies />;
      case 'transactions':
        return <Transactions />;
      case 'salary':
        return <SalaryCalculator />;
      case 'settings':
        return <ChangePassword />;
      default:
        return <Overview />;
    }
  };

  return (
    <div className="app-container">
      <header className="header">
        <div className="header-logo">💰 Benefices</div>
        <div className="header-user">
          <span>
            Welcome, <strong>{user?.full_name}</strong>
            {isAdmin && <span style={{ marginLeft: '8px', opacity: 0.7 }}>(Admin)</span>}
          </span>
          <button className="btn-logout" onClick={logout}>
            Sign Out
          </button>
        </div>
      </header>

      <main className="main-content">
        <nav className="nav-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </nav>

        {renderContent()}
      </main>
    </div>
  );
};

export default Dashboard;
